import classes from "./Box.module.css";
import { useEffect, useState } from "react";
import { useStore } from "./../../../hooks/store";

const Medium = (props) => {
  const [bgColor, setBgColor] = useState(null);
  const state = useStore()[0];

  const customTypes = [
    ...state.types,
    {
      id: "1",
      name: "Περιβαλλοντικά Δεδομένα",
      icon: "im im im im-icon-Globe",
      tooltip:
        "Δεδομένα που αφορούν τις περιβαλλοντικές συνθήκες και λαμβάνονται από τους 5 περιβαλλοντικούς σταθμούς του δήμου",
      color: "#33D453",
      isActive: true,
    },
    {
      id: "32",
      name: "Έξυπνες διαβάσεις",
      icon: "im im im im-icon-traffic-Light",
      color: "#31A9DE",
      tooltip: "Έξυπνες διαβάσεις",
      isActive: true,
    },
  ];
  useEffect(() => {
    if (customTypes.length > 0 && props.typeId) {
      const indexP = customTypes.findIndex((item) => item.id === props.typeId);
      if (indexP !== -1) {
        setBgColor({
          backgroundColor: customTypes[indexP].color,
        });
      }
    }
  }, [state.types, props.typeId]);

  return (
    <div
      className={[classes.box, props.className].join(" ")}
      style={bgColor ? bgColor : null}
    >
      {props.children}
    </div>
  );
};

export default Medium;
